
<div class="authenticated-layout" [class.with-debug-bar]="!debugBar()?.hidden()">
	<layout-header
		[isAuthenticated]="isAuthenticated"
		[currentLanguage]="currentLanguage$ | async"
		[currentActionId]="currentActionId$ | async"
		[userSession]="userSession$ | async"
		[tenant]="tenant$ | async"
		(lang)="setLanguage($event)"
		(logout)="logout()"
	/>

	<section id="content">
		<main id="main" scrolledByContainer>
			<router-outlet/>
		</main>
	</section>
</div>

<footer id="footer" class="has-bg">
	<div class="footer-legal-text">
		<span class="footer-legal">© 2019 - {{year}} <a [href]="('webSiteUrl' | branding)()" target="_blank" data-cy="OpenTabLegal">
			@if (('code' | branding)(); as brandingCode) {
				<img src="assets/images/logos/logo_{{brandingCode.toLowerCase()}}_white.png" [width]="125" [height]="29" [alt]="('name' | branding)()">
			} @else {
				<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" [width]="125" [height]="29" [alt]="'App.Name' | translate">
			}
		</a></span>
	</div>
</footer>

<debug-bar/>
